import React from "react";

import ContactDetails from "../ContactDetails";

const Intro3 = ({ language }) => {
  const text = getText(language);
  return (
    <div>
      {text}
      <ContactDetails language={language} appName="Permanent Residence" />
    </div>
  );
};

const getText = (language) => {
  switch (language) {
    case "en":
      return (
        <>
          <p>
            We cannot guarantee that the results of this assessment will always
            be 100% accurate and this should not be relied upon as legal advice.
            If you’re unsure about any details, or if your circumstances are not
            covered, please contact us.
          </p>
          <p>
            To verify your result, please{" "}
            <strong>
              email the pdf report of your answers to our caseworkers at the
              email address below
            </strong>
            , who will review the conclusion based on the answers provided.
          </p>
          <p>
            The AIRE Centre will not store nor make any attempt to identify
            individual user data as a result of your usage of this app.
          </p>
        </>
      );
    case "bg":
      return (
        <>
          <p>
            Ние не можем да гарантираме, че резултатите от този въпросник винаги
            ще бъдат 100% точни и това не трябва да бъде приемано като правен
            съвет. Ако не сте сигурни относно някои подробности или ако Вашата
            ситуация не е спомената, моля свържете се с нас.
          </p>
          <p>
            За да проверите своите резултати, моля изпратете имейл с pdf
            версията на Вашите отговори на имейл адреса по-долу, за да проверим
            заключенията въз основа на предоставените отговори.
          </p>
          <p>
            The AIRE Centre няма да съхранява или свърже данните с конкретно
            лице в следствие на използването на тази апликация.
          </p>
        </>
      );
    case "it":
      return (
        <>
          <p>
            Non possiamo garantire che i risultati di questa valutazione saranno
            sempre precisi al 100% e non ci si deve basare sulla stessa come
            fosse un parere legale. Se sei incerto su un qualsiasi dettaglio, o
            se le tue circostanze non sono ricomprese, ti preghiamo di
            contattarci.
          </p>
          <p>
            Per verificare il tuo risultato, sei pregato di inviare via e-mail,
            in versione PDF, il report delle tue risposte ai nostri
            collaboratori al seguente indirizzo e-mail, che rivedranno la
            conclusione in base alle risposte fornite.
          </p>
          <p>
            Il Centro AIRE non conserverà né tenterà di identificare i dati
            individuali degli utilizzatori di questa applicazione.
          </p>
        </>
      );
    case "ru":
      return (
        <>
          <p>
            Мы не можем гарантировать, что результаты этой оценки всегда будут
            на 100% точными, и на это не следует полагаться как на юридическую
            консультацию. Если вы не уверены в каких-либо подробностях или если
            ваши обстоятельства здесь не указаны, свяжитесь с нами.
          </p>
          <p>
            Чтобы подвердить свой результат, отправьте отчет в формате PDF с
            вашими ответами нашим сотрудникам по указанному ниже адресу
            электронной почты, которые рассмотрят результат на основе
            предоставленных ответов.
          </p>
          <p>
            AIRE Center не хранит и не идентифицирует данные отдельных
            пользователей в результате использования вами этого приложения.
          </p>
        </>
      );
    case "es":
      return (
        <>
          <p>
            No podemos garantizar que los resultados de esta evaluación sean
            siempre 100% exactos y no se debe confiar en ello como asesoramiento
            legal. Si no está seguro de algún detalle, o si sus circunstancias
            no están cubiertas, por favor contáctenos.
          </p>
          <p>
            Para verificar su resultado, por favor envíe por correo electrónico
            el informe en pdf de sus respuestas a nuestros asistentes a la
            siguiente dirección de correo electrónico, quienes revisarán el caso
            en base a las respuestas proporcionadas.
          </p>
          <p>
            El Centro AIRE no almacenará ni intentará identificar los datos
            individuales de los usuarios como resultado del uso de esta
            aplicación.
          </p>
        </>
      );
    case "hi":
      return (
        <>
          <p>
            हम इस बात की गारंटी नहीं दे सकते हैं कि इस मूल्यांकन के परिणाम हमेशा
            100% सटीक होंगे और इस पर कानूनी सलाह के रूप में भरोसा नहीं किया जाना
            चाहिए। यदि आप किसी भी विवरण के बारे में अनिश्चित हैं, या यदि आपकी
            परिस्थितियाँ शामिल नहीं हैं, तो कृपया हमसे संपर्क करें।
          </p>
          <p>
            अपना परिणाम सत्यापित करने के लिए, कृपया नीचे दिए गए ईमेल पते पर
            हमारे कैसवर्कर्स को अपने उत्तरों की पीडीएफ रिपोर्ट ईमेल करें, जो दिए
            गए उत्तरों के आधार पर निष्कर्ष की समीक्षा करेंगे।
          </p>
          <p>
            एआईआरई सेंटर इस ऐप के आपके उपयोग के परिणामस्वरूप व्यक्तिगत
            उपयोगकर्ता डेटा की पहचान करने का कोई प्रयास नहीं करेगा और न ही
            करेगा।
          </p>
        </>
      );

    default:
      break;
  }
};

export default Intro3;
